import { DEFAULT_DIAL, DIAL_CODES } from "../constants/dial-codes";

const DIALS = Array.from(new Set(DIAL_CODES.map((c) => c.dial))).sort((a, b) => b.length - a.length);

export interface PhoneParts {
  dial: string;
  number: string;
}

/**
 * Splits whatever was typed or stored into a calling code and the rest, whether it starts with +39, 0039 or nothing:
 * "+39 333 1234567", "0039333 1234567" and "3331234567" all give { dial: "+39", number: "3331234567" }.
 */
export function splitPhone(raw: string | null | undefined, fallbackDial = DEFAULT_DIAL): PhoneParts {
  let text = String(raw ?? "").trim();
  const international = text.startsWith("+") || text.startsWith("00");
  text = text.replace(/[^\d]/g, "");
  if (!international) return { dial: fallbackDial, number: text };

  if (String(raw).trim().startsWith("00")) text = text.slice(2);
  const dial = DIALS.find((d) => text.startsWith(d.slice(1)));
  return dial ? { dial, number: text.slice(dial.length - 1) } : { dial: fallbackDial, number: text };
}

/** "+39" and "333 1234567" become "+39 3331234567"; no number means no phone at all. */
export function joinPhone(dial: string, number: string): string {
  const digits = String(number ?? "").replace(/[^\d]/g, "");
  return digits ? `${dial} ${digits}` : "";
}
